import React from 'react';
import {findDOMNode} from 'react-dom';
import Popover from "../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../gd-components/gd-popover/popover-position";
import {PopoverAttachmentType} from "../../gd-components/gd-popover/@const";

type State = {
    showPopover     : boolean
}

type Props = {
    hint                : string

    getTargetFunc?      : func
    checkShowHint?      : func
    onClick?            : onClick

    type?               : 'default' | 'small'
    multiline?          : boolean

    showDelay?          : number
    hideDelay?          : number

    attachment?         : string
    targetAttachment?   : string
    attachmentType?     : 'horizontal' | 'vertical'
    offset?             : string
    targetOffset?       : string

    color?              : 'black' | 'gray' | 'white'

    // extra class on the popover element itself - it is portalled to <body>,
    // so this is the only way to reach it from a caller's own stylesheet
    popoverClass?       : string
}


export default class HintPopover extends React.Component<any,State> {

    public parentEl         : any
    public debounceShowHint : any
    public debounceHideHint : any

    // static propTypes = {
    //     hint: PropTypes.string,
    //     getTargetFunc: PropTypes.func,
    //     checkShowHint: PropTypes.func,
    //     onClick: PropTypes.func,
    //
    //     type: PropTypes.oneOf(['default','small']),
    //     multiline: PropTypes.bool,
    //
    //     showDelay: PropTypes.number,
    //     hideDelay: PropTypes.number,
    //
    //     attachment: PropTypes.string,
    //     targetAttachment: PropTypes.string,
    //     attachmentType: PropTypes.oneOf(['horizontal','vertical']),
    //     offset: PropTypes.string,
    //     targetOffset: PropTypes.string,
    //
    //     color: PropTypes.oneOf(['black','gray']),
    // };

    static defaultProps = {
        type: 'default',
        multiline: false,
        showDelay: 200,
        hideDelay: 0,
        attachment: "top center",
        targetAttachment: "bottom center",
        attachmentType: "horizontal",
        offset: "0 -1",

        color:  "black"
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            showPopover: false
        }
    }

    componentDidMount() {
        // this.parentEl = findDOMNode(this.props.parent);
        this.parentEl = findDOMNode(this)?.parentNode;

        this.parentEl.addEventListener("mouseenter", this.show);
        this.parentEl.addEventListener("mouseleave", this.hide);
        this.parentEl.addEventListener("wheel", this.hide);

        this.debounceShowHint = this.props.showDelay === 0 ? this._showPopover : _.debounce(this._showPopover, this.props.showDelay);
        this.debounceHideHint = this.props.hideDelay === 0 ? this._hidePopover : _.debounce(this._hidePopover, this.props.hideDelay);
    }

    componentWillUnmount() {
        if (this.props.showDelay !== 0 && this.debounceShowHint) this.debounceShowHint.cancel();
        if (this.props.hideDelay !== 0 && this.debounceHideHint) this.debounceHideHint.cancel();

        this.parentEl.removeEventListener("mouseenter", this.show);
        this.parentEl.removeEventListener("mouseleave", this.hide);
        this.parentEl.removeEventListener("wheel", this.hide);
    }

    show = () => {
        if (this.props.checkShowHint) {
            if (this.props.checkShowHint()) this.debounceShowHint();
        } else {
            this.debounceShowHint();
        }
    }

    hide = () => {
        if (this.debounceShowHint) this.debounceShowHint.cancel();
        this.debounceHideHint();
    }

    _showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    _hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}
    onMouseEnter = () => {if (this.debounceHideHint) this.debounceHideHint.cancel()}
    onMouseLeave = () => {this.debounceHideHint();}

    onHintClick = () => {
        if (this.props.onClick) this.props.onClick();
        this._hidePopover();
    }

    render() {


        if (this.props.hint && this.state.showPopover) {
            const popoverClasses = Classes(this.props.type+"-type", this.props.popoverClass, {
                "gd-ui-hint-popover"        : this.props.color === 'black',
                "gd-ui-hint-popover-gray"   : this.props.color === 'gray',
                "gd-ui-hint-popover-white"  : this.props.color === 'white',
                'no-click'                  : !this.props.onClick,
                multiline                   : this.props.multiline
            })

            const hint = this.props.multiline && this.props.hint.includes('\\n') ?
                this.props.hint.split('\\n').map((text:any,key:any)=><p key={key}>{text}</p>) :
                this.props.hint;

            const popoverPosition = new PopoverPosition({
                attachment      : this.props.attachment,
                targetAttachment: this.props.targetAttachment,
                offset          : this.props.offset,
                targetOffset    : this.props.targetOffset,
                attachmentType  : this.props.attachmentType as PopoverAttachmentType,
            })

            return (
                <Popover popoverClass={popoverClasses}
                         getTargetFunc={this.props.getTargetFunc ?  this.props.getTargetFunc : ()=> {
                             return this.parentEl
                         }}
                         constraints={[{
                             to: 'window',
                             attachment: 'together',
                             pin: true
                         }]}
                         position={popoverPosition}
                         onClick={this.onHintClick}>
                    <div className="hint-text" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                        {hint}
                    </div>
                </Popover>
            );
        } else {
            // we need element to find (this)
            return <span className="empty-hint" />;
        }
    }
}
